import { COUNTRY_LIST, COUNTRY_LIST_SUCCESS, COUNTRY_LIST_FAILURE } from './actionTypes';
import * as types from './types';

// react plan
export const countryList = (): types.CountryListRequest => ({
    type: COUNTRY_LIST,
});

export const countryListSuccess = (payload: types.CountryListSuccessPayload): types.CountryListSuccess => ({
    type: COUNTRY_LIST_SUCCESS,
    payload,
});

export const countryListFailure = (payload: types.CountryListFailurePayload): types.CountryListFailure => ({
    type: COUNTRY_LIST_FAILURE,
    payload,
});
